<script>
  import IconClose from '@/components/atoms/IconClose'
  import Logo from '@/components/atoms/Logo'

  export default {
    name: 'ModalCheckPoint',
    components: {
      IconClose,
      Logo
    },
    data() {
      return {
        imgs: [
          require('@/assets/img/modal_img01.png'),
          require('@/assets/img/modal_img02.png'),
          require('@/assets/img/modal_img03.png'),
        ],
        titles: [
          require('@/assets/img/tutorial_title01.svg'),
          require('@/assets/img/tutorial_title02.svg'),
          require('@/assets/img/tutorial_title03.svg'),
        ],
        texts: [
          '毎日更新される住友生命「Vitality」や健康・運動についての質問に答えよう！',
          '回答はTwitterに投稿！みんなに\n楽しんでいるところをアピールしよう！',
          '投稿するとスタンプをGET！\nどんどん答えて、目指せ20問達成！',
        ],
        contentId: 0,
        timer: null
      }
    },
    mounted() {
      this.timer = setInterval(() => {
        this.contentId++;
        if(this.contentId === 3) {
          this.contentId = 0;
        }
      }, 4000);
    },
    methods: {
      stylesContents(i) {
        return {
          opacity: (this.contentId === i) ? 1 : 0
        }
      },
      close() {
        this.$store.commit('toggleModalIntro', false);
        clearInterval(this.timer);
      }
    }
  }
</script>

<template lang="pug">
  transition(
    name = 'modal-intro'
    )
    .modal-intro(
      v-if = '$store.state.isShownModalIntro === true'
      )
      .modal-intro__body-wrap
        .modal-intro__body
          .modal-intro__body-in
            .modal-intro__body-row1
              Logo.modal-intro__logo
              .modal-intro__date
                |開催期間：2/3～3/16
              .modal-intro__titles
                .modal-intro__titles-in
                  img.modal-intro__title(
                    v-for = 'title, index in titles'
                    :src = 'title'
                    :style = 'stylesContents(index)'
                    )
              .modal-intro__imgs
                .modal-intro__imgs-in
                  img.modal-intro__img(
                    v-for = 'img, index in imgs'
                    :src = 'img'
                    :style = 'stylesContents(index)'
                    )
            .modal-intro__body-row2
              .modal-intro__texts
                .modal-intro__texts-in
                  .modal-intro__text(
                    v-for = 'text, index in texts'
                    v-text = 'text'
                    :style = 'stylesContents(index)'
                    )
              img.modal-intro__lets-start(
                src = '~@/assets/img/text_lets.svg'
                )
              .modal-intro__start(
                @click = 'close'
                )
                |START!
            .modal-intro__close(
              @click = 'close'
              )
              IconClose
      .modal-intro__bg(
        @click = 'close'
        )
</template>

<style lang="scss">
  .modal-intro {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
    transform: translate3d(0, 0, 0);
    &__body-wrap {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      overflow-y: scroll;
      @include l-more-than-mobile {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    &__body {
      box-sizing: border-box;
      overflow: hidden;
      margin: auto;
      border-radius: 8px;
      background-color: #fff;
      z-index: 1;
      @include l-more-than-mobile {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 520px;
        height: 577px;
      }
      @include l-mobile {
        position: relative;
        width: 100%;
        max-width: 335px;
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }
    &__body-in {
      height: 100%;
      width: 100%;
      @include l-mobile {
        padding-bottom: 20px;
      }
    }
    &__body-row1 {
      @include l-more-than-mobile {
        padding-top: 30px;
      }
      @include l-mobile {
        padding-top: 20px;
      }
    }
    &__logo {
      display: block;
      margin-right: auto;
      margin-left: auto;
      @include l-more-than-mobile {
        width: 200px;
        height: 90px;
        margin-bottom: 8px;
      }
      @include l-mobile {
        width: 150px;
        height: 70px;
        margin-bottom: 3px;
      }
    }
    &__date {
      margin-bottom: 20px;
      color: $primary-color;
      @include fontSizeAll(16, 12);
      text-align: center;
      font-weight: bold;
    }
    &__imgs {
      margin-right: auto;
      margin-left: auto;
      @include l-more-than-mobile {
        width: 320px;
      }
      @include l-mobile {
        max-width: 295px;
      }
    }
    &__imgs-in {
      width: 100%;
      position: relative;
      padding-top: 150 / 320 * 100%;
    }
    &__img {
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
    }
    &__titles {
      max-height: 23px;
      margin-right: auto;
      margin-left: auto;
      @include l-more-than-mobile {
        margin-bottom: 20px;
      }
      @include l-mobile {
        margin-bottom: 15 / 335 * 100%;
      }
    }
    &__titles-in {
      width: 100%;
      position: relative;
      padding-top: 23px;
    }
    &__title {
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
    }
    &__body-row2 {
      @include l-more-than-mobile {
        padding-top: 20px;
        padding-right: 30px;
        padding-left: 30px;
      }
      @include l-mobile {
        padding-top: 15 / 335 * 100%;
        padding-right: 20px;
        padding-left: 20px;
      }
    }
    &__texts {
      margin-right: auto;
      margin-left: auto;
      @include l-more-than-mobile {
        max-height: 68px;
        margin-bottom: 20px;
      }
      @include l-mobile {
        height: 80px;
        margin-bottom: 20 / 335 * 100%;
      }
    }
    &__texts-in {
      width: 100%;
      position: relative;
      @include l-more-than-mobile {
        padding-top: 68px;
      }
      @include l-mobile {
        padding-top: 80px;
      }
    }
    &__text {
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      line-height: (20 / 14);
      @include fontSize(14);
      white-space: pre-wrap;
    }
    &__lets-start {
      display: block;
      margin-bottom: 10px;
      margin-right: auto;
      margin-left: auto;
    }
    &__start {
      height: 55px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: auto;
      margin-left: auto;
      border-radius: 28px;
      color: #fff;
      @include fontSize(24);
      font-weight: 700;
      background-color: $primary-color;
      @include l-more-than-mobile {
        width: 267px;
      }
      @include l-mobile {
        width: 267 / 295 * 100%;
        min-width: 240px;
      }
    }
    &__close {
      width: 44px;
      height: 44px;
      cursor: pointer;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 4px;
      right: 4px;
    }
    &__bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.7);
    }

    //
    // 表示・非表示アニメーション
    &.modal-intro-enter-to {
      transition-duration: 0.2s;
    }
    &.modal-intro-leave-to {
      transition-duration: 0.23s;
    }

    &__body {
      .modal-intro-enter & {
        opacity: 0;
        transform: scale(0.9);
      }
      .modal-intro-enter-to & {
        opacity: 1;
        transform: scale(1);
        transition-duration: 0.2s;
        transition-property: opacity, transform;
        transition-timing-function: $easeOutQuad;
      }
      .modal-intro-leave-to & {
        opacity: 0;
        transform: scale(0.9);
        transition-duration: 0.23s;
        transition-property: opacity, transform;
        transition-timing-function: $easeInQuad;
      }
    }

    &__bg {
      .modal-intro-enter & {
        opacity: 0;
      }
      .modal-intro-enter-to & {
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: opacity;
      }
      .modal-intro-leave-to & {
        opacity: 0;
        transition-duration: 0.23s;
        transition-property: opacity;
      }
    }

    //
    // チュートリアルアニメーション
    &__title, &__text, &__img {
      transition-duration: .2s;
      transition-property: opacity;
    }
  }
</style>
